import React, { useEffect, useState } from 'react';
import { Card } from '@playground/ui';
import { apiFetch } from '@/platform/api.js';

interface Stats {
  activeRooms: number;
  gamesToday: number;
  gamesTotal: number;
}

export function Dashboard({ token }: { token: string }) {
  const [stats, setStats] = useState<Stats | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    apiFetch('/api/admin/stats', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (!r.ok) throw new Error('Unauthorized');
        return r.json() as Promise<Stats>;
      })
      .then(setStats)
      .catch(() => setError(true));
  }, [token]);

  if (error) {
    return <p className="text-red-500 text-sm">Failed to load stats.</p>;
  }

  const statCards = [
    { label: 'Active Rooms', value: stats?.activeRooms ?? '—', color: 'text-indigo-600 dark:text-indigo-400' },
    { label: 'Games Today', value: stats?.gamesToday ?? '—', color: 'text-green-600 dark:text-green-400' },
    // `text-gray-700` alone is near-invisible on the dark panel background.
    { label: 'Games All Time', value: stats?.gamesTotal ?? '—', color: 'text-gray-700 dark:text-gray-200' },
  ];

  return (
    <div>
      <h2 className="mb-4 text-lg font-semibold text-gray-800 dark:text-gray-100">Dashboard</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {statCards.map((s) => (
          <Card key={s.label}>
            <p className="text-sm text-gray-500 dark:text-gray-400">{s.label}</p>
            <p className={`mt-1 text-3xl font-bold ${s.color}`}>{s.value}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
